module.exports = __webpack_public_path__ + "static/media/btn_apple_ita.32b15d69.png";